import { useMutation } from '@tanstack/react-query';
import { apiPostFile, apiPost } from '../services/api';

export interface KonfidensVerdi {
  verdi: string | number | null;
  konfidens: number;
  source_quote: string | null;
}

export interface MissingQuestion {
  felt: string;
  sporsmal: string;
}

export interface DokumentTolkning {
  [key: string]: KonfidensVerdi | MissingQuestion[] | undefined;
  missing_questions: MissingQuestion[];
}

interface UploadResponse {
  success: boolean;
  data: {
    dokumentId: string;
    filename: string;
    tolkning: DokumentTolkning;
    extractionMethod: string;
    charCount: number;
  };
}

interface AnswersResponse {
  success: boolean;
  data: {
    tolkning: DokumentTolkning;
  };
}

interface FinalizeResponse {
  success: boolean;
  data: {
    avtaleId: string;
    dokumentId: string;
    finalFilename: string;
  };
}

export function useUploadFile() {
  return useMutation({
    mutationFn: (file: File) =>
      apiPostFile<UploadResponse>('/upload', file),
  });
}

export function useSubmitAnswers() {
  return useMutation({
    mutationFn: (params: {
      dokumentId: string;
      tolkning: DokumentTolkning;
      answers?: Record<string, string | number | null>;
      freeText?: string;
      missingQuestions?: MissingQuestion[];
    }) =>
      apiPost<AnswersResponse>(`/upload/${params.dokumentId}/answers`, {
        tolkning: params.tolkning,
        answers: params.answers,
        freeText: params.freeText,
        missingQuestions: params.missingQuestions,
      }),
  });
}

export function useFinalize() {
  return useMutation({
    mutationFn: (params: {
      dokumentId: string;
      tolkning: DokumentTolkning;
      inntektslinjeID?: string;
    }) =>
      apiPost<FinalizeResponse>(`/upload/${params.dokumentId}/finalize`, {
        tolkning: params.tolkning,
        inntektslinjeID: params.inntektslinjeID,
      }),
  });
}

// Known tolkning fields (excludes missing_questions)
export const TOLKNING_FIELDS = [
  'Tittel', 'Betaler', 'Kategori', 'Beskrivelse', 'Startdato', 'Sluttdato',
  'Beloep_gjeldende', 'Beloep_gjelder_fra', 'Faktureringsfrekvens',
  'Prislogikk_type', 'Indeks_type', 'Variabler',
  'Risiko_sannsynlighet', 'Risiko_kommentar', 'Inntektsmekanikk',
] as const;

export const FELT_LABELS: Record<string, string> = {
  Tittel: 'Tittel',
  Betaler: 'Betaler',
  Kategori: 'Kategori',
  Beskrivelse: 'Beskrivelse',
  Startdato: 'Startdato',
  Sluttdato: 'Sluttdato',
  Beloep_gjeldende: 'Beløp (gjeldende)',
  Beloep_gjelder_fra: 'Beløp gjelder fra',
  Faktureringsfrekvens: 'Faktureringsfrekvens',
  Prislogikk_type: 'Prislogikk',
  Indeks_type: 'Indekstype',
  Variabler: 'Variabler',
  Risiko_sannsynlighet: 'Risikosannsynlighet',
  Risiko_kommentar: 'Risikokommentar',
  Inntektsmekanikk: 'Inntektsmekanikk',
};
